// extracted by mini-css-extract-plugin
module.exports = {"button":"SaltVoteButton_button__F24IE"};